module.exports = __webpack_public_path__ + "img/view_icon.2947fcc9.svg";